import { z } from 'zod';
import { NamespaceSchema } from './namespaces.js';
export const StorageRecordSchema = z.object({
    namespace: NamespaceSchema,
    key: z.string().min(1),
    value: z.unknown(),
    updatedAt: z.string().min(1),
    deletedAt: z.string().optional(),
    version: z.number().int().nonnegative().optional(),
});
export const RecordRefSchema = z.object({
    namespace: NamespaceSchema,
    key: z.string().min(1),
    updatedAt: z.string().min(1),
    deletedAt: z.string().optional(),
});
//# sourceMappingURL=record-schema.js.map